import { render } from "./TurnstileChallenge.vue?vue&type=template&id=ec005044&scoped=true"
import script from "./TurnstileChallenge.vue?vue&type=script&lang=ts"
export * from "./TurnstileChallenge.vue?vue&type=script&lang=ts"

import "./TurnstileChallenge.vue?vue&type=style&index=0&id=ec005044&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-ec005044"

export default script